import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Message from 'js/components/atoms/Label/Message';
import { AUTH_ROUTE_PATH } from 'js/constants/routes';
import { localizedText } from 'js/localization';
var LOG_IN_LINK_TEXT = localizedText.LOG_IN_LINK_TEXT;
export default function ResetPasswordPage(_ref) {
  var _ref$messages = _ref.messages,
      messages = _ref$messages === void 0 ? {} : _ref$messages,
      resetPasswordSubmit = _ref.resetPasswordSubmit,
      onRequestResetPasswordSubmit = _ref.onRequestResetPasswordSubmit,
      resetPasswordIsSubmitting = _ref.resetPasswordIsSubmitting;
  return React.createElement("div", null, React.createElement("strong", null, "Reset Password"), React.createElement("br", null), React.createElement("small", null, "Enter the e-mail associated with your Cosmos account in the text box and then click the\n        \"Reset password\" button"), React.createElement(Message, {
    message: messages.success,
    type: 'success'
  }), React.createElement(Message, {
    message: messages.error,
    type: 'error'
  }), messages.success ? React.createElement("form", {
    method: "POST",
    action: "#",
    onSubmit: resetPasswordSubmit
  }, React.createElement("label", {
    htmlFor: "email"
  }, "Confirm e-mail:", React.createElement("br", null), React.createElement("input", {
    className: "form-control",
    type: "email",
    id: "email",
    name: "email",
    required: true
  })), React.createElement("br", null), React.createElement("label", {
    htmlFor: "email"
  }, "Enter reset password code:", React.createElement("br", null), React.createElement("input", {
    className: "form-control",
    type: "text",
    name: "code"
  })), React.createElement("br", null), React.createElement("label", {
    htmlFor: "password"
  }, "Set new password:", React.createElement("br", null), React.createElement("input", {
    className: "form-control",
    type: "password",
    name: "new_password"
  })), React.createElement("br", null), React.createElement("br", null), React.createElement("button", {
    disabled: !!resetPasswordIsSubmitting,
    type: "submit",
    className: "btn btn-primary"
  }, "Reset password"), React.createElement("br", null), React.createElement("span", null, "Remembered your password?", ' ', React.createElement(Link, {
    to: AUTH_ROUTE_PATH
  }, (LOG_IN_LINK_TEXT, 'Login')))) : React.createElement("form", {
    method: "POST",
    action: "#",
    onSubmit: onRequestResetPasswordSubmit
  }, React.createElement("label", {
    htmlFor: "email"
  }, "Email", React.createElement("br", null), React.createElement("input", {
    className: "form-control",
    type: "email",
    name: "email"
  })), React.createElement("br", null), React.createElement("button", {
    disabled: !!resetPasswordIsSubmitting,
    type: "submit",
    className: "btn btn-primary"
  }, "Email reset password code"), React.createElement("br", null), React.createElement("span", null, "Remembered your password?", ' ', React.createElement(Link, {
    to: AUTH_ROUTE_PATH
  }, (LOG_IN_LINK_TEXT, 'Login')))));
}
ResetPasswordPage.propTypes = {
  emailVerification: PropTypes.string,
  messages: PropTypes.array,
  resetPasswordSubmit: PropTypes.func.isRequired,
  onRequestResetPasswordSubmit: PropTypes.func.isRequired,
  setPasswordIsSubmitting: PropTypes.bool.isRequired,
  resetPasswordIsSubmitting: PropTypes.bool.isRequired
};